export function inputHolderAnimation() {
    let className = "filled";
    let wrapper = ".form-holder";

    $("input").focus(function () {
        $(this).parents(wrapper).addClass(className);
    }).blur(function () {
        let inputIsEmpty = $(this).val().length === 0;

        if (inputIsEmpty) {
            $(this).parents(wrapper).removeClass(className);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/inputHolderAnimation.js